import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectIsAuthenticated, selectCurrentUser } from '../../store/slices/authSlice';

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectCurrentUser);
  const location = useLocation();

  // Redux is already rehydrated by the time any route renders (App.js gates
  // the whole tree on PersistGate), so isAuthenticated is reliable here
  // without a separate loading gate.
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRoles.length > 0 && user && !requiredRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default React.memo(ProtectedRoute);